export const normalizeCurrency2 = val => {
	if (localStorage.getItem('language') === 'fr') {
		const normalized = val
			.replace(/ /g, '')
			.replace(/\./g, ',')
			.replace(/(?!-)[^0-9,]/g, '');
		if (isNaN(normalized)) {
			if (normalized.split(',').length > 2) { return normalized.replace(/,+$/, ''); }
		}
		return normalized;
	} else {
		const normalized = val
			.replace(/ /g, '')
			.replace(/,/g, '.')
			.replace(/(?!-)[^0-9.]/g, '');
		if (isNaN(normalized)) {
			if (normalized.split('.').length > 2) { return normalized.replace(/\.+$/, ''); }
		}
		return normalized;
	}
};


export const normalizeCapitalize = val =>
	val && val.charAt(0).toUpperCase() + val.slice(1);